import React, { Component } from 'react';
export default class Header extends Component {
    render() {
        let resumeData = this.props.resumeData;
        return (<React.Fragment> {
            <header id = "home">
                <nav id = "nav-wrap">
                    <a className = "mobile-btn" href = "#nav-wrap" title = "Show navigation"> Show navigation </a>
                    <a className = "mobile-btn" href = "#" title = "Hide navigation"> Hide navigation </a>
                    <ul id = "nav" className = "nav">
                        <li className = "current">
                            <a className = "smoothscroll" href = "#home"> Home </a>
                        </li>
                        <li>
                            <a className = "smoothscroll" href = "#about"> About </a>
                        </li>
                        <li>
                            <a className = "smoothscroll" href = "#resume"> Resume </a>
                        </li>
                        {
                            /*
                            <li>
                                <a className = "smoothscroll" href = "#portfolio"> Works </a>
                            </li>
                            <li>
                                <a className = "smoothscroll" href = "#testimonials"> Testimonials </a>
                            </li>
                            <li>
                                <a className = "smoothscroll" href = "#contact"> Contact </a>
                            </li >
                            */
                        }
                    </ul> {/* end #nav */}
                </nav> {/* end #nav-wrap */}
                <div className = "row banner">
                    <div className = "banner-text">
                        <h1 className = "responsive-headline"> {resumeData.name}. </h1>
                        <h3> I am a MS Computer Science student at Georgia Tech with strong passion in researching robust and cost-efficient ML models and delivering trustworthy AI solutions to production. <br/> </h3>
                        <hr/>
                        <ul className = "social">
                            <li>
                                <a href = {resumeData.facebook_link}> <i className = "fa fa-facebook"/> </a>
                            </li>
                            {
                                /*
                                <li>
                                    <a href="#"> <i className="fa fa-twitter"/> </a>
                                </li>
                                <li>
                                    <a href="#"> <i className="fa fa-google-plus"/> </a>
                                </li>
                                */
                            }
                            <li>
                                <a href = {resumeData.instagram_link}> <i className = "fa fa-instagram"/> </a>
                            </li>
                            <li>
                                <a href = {resumeData.linkedin_link}> <i className = "fa fa-linkedin"/> </a>
                            </li>
                            {
                                /*
                                <li>
                                    <a href="#"> <i className="fa fa-dribbble"/> </a>
                                </li>
                                <li>
                                    <a href="#"> <i className="fa fa-skype"/> </a>
                                </li>
                                */
                            }
                            <li>
                                <a href = {resumeData.github_repo}> <i className = "fa fa-github"/> </a>
                            </li>
                            <li>
                                <a href = {resumeData.email_link}> <i className = "fa fa-envelope"/> </a>
                            </li>
                        </ul>
                    </div>
                </div>
                <p className = "scrolldown">
                    <a className = "smoothscroll" href = "#about">
                        <i className = "icon-down-circle"/>
                    </a>
                </p>
            </header>}
        </React.Fragment>);
    }
}